module.exports = __webpack_public_path__ + "static/media/kwara_logo.b8e4d996.svg";